export default __webpack_public_path__ + "static/media/gauda_krug-1.9d9a385c.jpg";